// ─── NAVBAR SCROLL ───────────────────────────────────────────────────
const navbar = document.getElementById('navbar');

window.addEventListener('scroll', () => {
  if (window.scrollY > 20) {
    navbar.classList.add('bg-white/90', 'backdrop-blur-md', 'border-b', 'border-gray-100', 'py-4');
    navbar.classList.remove('py-5');
  } else {
    navbar.classList.remove('bg-white/90', 'backdrop-blur-md', 'border-b', 'border-gray-100', 'py-4');
    navbar.classList.add('py-5');
  }
});

// ─── MOBILE MENU ─────────────────────────────────────────────────────
function toggleMobileMenu() {
  const menu = document.getElementById('mobileMenu');
  const bar1 = document.getElementById('bar1');
  const bar2 = document.getElementById('bar2');
  const bar3 = document.getElementById('bar3');
  const isOpen = !menu.classList.contains('hidden');

  if (isOpen) {
    menu.classList.add('hidden');
    bar1.style.transform = '';
    bar2.style.opacity  = '';
    bar3.style.transform = '';
  } else {
    menu.classList.remove('hidden');
    bar1.style.transform = 'translateY(6px) rotate(45deg)';
    bar2.style.opacity   = '0';
    bar3.style.transform = 'translateY(-6px) rotate(-45deg)';
  }
}

// ─── CALCULATOR ──────────────────────────────────────────────────────
let currentPlan = 3;

function selectPlan(months) {
  currentPlan = months;
  const btn3 = document.getElementById('plan3btn');
  const btn6 = document.getElementById('plan6btn');

  const activeClass   = 'p-4 sm:p-6 rounded-[20px] sm:rounded-[24px] border-2 transition-all text-left border-black bg-white shadow-xl';
  const inactiveClass = 'p-4 sm:p-6 rounded-[20px] sm:rounded-[24px] border-2 transition-all text-left border-gray-100 bg-transparent hover:border-gray-300';

  if (months === 3) {
    btn3.className = activeClass;
    btn6.className = inactiveClass;
  } else {
    btn6.className = activeClass;
    btn3.className = inactiveClass;
  }

  updateCalculator();
}

function updateCalculator() {
  const price       = parseFloat(document.getElementById('priceInput').value) || 0;
  const depositRate = currentPlan === 3 ? 0.25 : 0.30;
  const deposit     = price * depositRate;
  const remaining   = price - deposit;
  const monthly     = remaining / currentPlan;

  document.getElementById('depositAmt').textContent  = '$' + Math.round(deposit).toLocaleString();
  document.getElementById('remainingAmt').textContent = '$' + Math.round(remaining).toLocaleString();
  document.getElementById('monthlyAmt').textContent   = '$' + Math.round(monthly).toLocaleString();
  document.getElementById('planLabel').textContent    = currentPlan + ' Month Schedule';

  // Build payment schedule rows
  const scheduleEl = document.getElementById('paymentSchedule');
  scheduleEl.innerHTML = '';
  const today = new Date();

  for (let i = 1; i <= currentPlan; i++) {
    const payDate = new Date(today.getFullYear(), today.getMonth() + i, today.getDate());
    const dateStr = payDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

    const row = document.createElement('div');
    row.className = 'flex justify-between items-center bg-white/5 rounded-2xl p-4 border border-white/5 hover:bg-white/10 transition-colors';
    row.innerHTML = `
      <div class="flex items-center gap-4">
        <div class="w-8 h-8 rounded-xl bg-[#a855f7]/20 flex items-center justify-center text-[#a855f7] font-black text-[10px]">${i}</div>
        <div>
          <p class="text-[11px] font-black uppercase tracking-widest leading-none mb-1">Payment ${i}</p>
          <p class="text-[10px] text-gray-500 font-bold uppercase tracking-widest leading-none">${dateStr}</p>
        </div>
      </div>
      <span class="text-lg font-black tracking-tight">$${Math.round(monthly).toLocaleString()}</span>
    `;
    scheduleEl.appendChild(row);
  }
}

// ─── FAQ ACCORDION ────────────────────────────────────────────────────
function toggleFaq(btn) {
  const item    = btn.closest('.faq-item');
  const answer  = item.querySelector('.faq-answer');
  const chevron = btn.querySelector('.faq-chevron');
  const isOpen  = answer.classList.contains('open');

  // Close all open items first
  document.querySelectorAll('.faq-item').forEach(i => {
    const a = i.querySelector('.faq-answer');
    const c = i.querySelector('.faq-chevron');
    a.style.maxHeight = '0px';
    a.classList.remove('open');
    c.classList.remove('open');
    c.style.color = '';
    i.classList.remove('bg-gray-50');
  });

  // Open clicked item if it was closed
  if (!isOpen) {
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.classList.add('open');
    chevron.classList.add('open');
    chevron.style.color = '#a855f7';
    item.classList.add('bg-gray-50');
  }
}

// ─── INIT ─────────────────────────────────────────────────────────────
document.querySelectorAll('.faq-answer').forEach(a => {
  a.style.maxHeight = '0px';
});

updateCalculator();
